import React from "react";
import { motion, HTMLMotionProps } from "framer-motion";

const PADDING = {
  none: "",
  sm: "p-3",
  md: "p-5",
  lg: "p-8",
} as const;

export interface CardProps extends Omit<HTMLMotionProps<"div">, "children"> {
  children: React.ReactNode;
  className?: string;
  padding?: keyof typeof PADDING;
  interactive?: boolean;
  glass?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(({
  children,
  className = "",
  padding = "md",
  interactive = false,
  glass = false,
  ...rest
}, ref) => {
  return (
    <motion.div
      ref={ref}
      whileHover={interactive ? { y: -2, boxShadow: "var(--shadow-md)" } : {}}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className={[
        glass ? "bg-white/80 backdrop-blur-md border border-white/40" : "bg-surface border-ink-200",
        "rounded-xl border shadow-sm",
        PADDING[padding],
        interactive ? "cursor-pointer transition-colors hover:border-ink-300" : "",
        className,
      ].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </motion.div>
  );
});

Card.displayName = "Card";
export default Card;
